import React from 'react'
import Aside from './Aside.tsx'
import Card from './Card.tsx'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import { IEcommerceQuestionSchema } from '@aytm/app/swidget/base/questions/Ecommerce/types'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './Main.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale.ts'

interface IMainProps {
  containerTop: number
  schema: IEcommerceQuestionSchema
  onItemSelect: (index: number) => void
  registerCardRef: (id: string, element: HTMLDivElement | null) => void
}

const Main = ({ containerTop, schema, onItemSelect, registerCardRef }: IMainProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()

  return (
    <>
      <div className={`${style.bottom} ${viewport.mobile ? style.bottomMobile : ''}`}>
        {schema.search_condition && <div className={style.resultsText}>{t('questions', 'ec', 'nike', 'results')}</div>}
        <div
          className={style.results}
          style={{ justifyContent: schema.search_condition ? 'space-between' : 'flex-end' }}
        >
          {schema.search_condition && (
            <div
              className={`${style.condition} ${containerTop > 40 ? style.conditionSmall : ''}`}
              dangerouslySetInnerHTML={{ __html: `${schema.search_condition} (${schema.answers.length})` }}
            />
          )}
          <div className={style.filters}>
            <EmptyLink color="#111">
              <div className={style.filterItem}>
                <span className={style.text}>{t('questions', 'ec', 'nike', 'hideFilters')}</span>
                <div className={style.filtersIcon} />
              </div>
            </EmptyLink>
            <EmptyLink color="#111">
              <div className={style.filterItem}>
                <span className={style.text}>{t('questions', 'ec', 'nike', 'sortBy')}</span>
                <div className={style.downIcon} />
              </div>
            </EmptyLink>
          </div>
        </div>
      </div>
      <section className={`${style.main} ${viewport.mobile ? style.mainMobile : ''}`}>
        <Aside />
        <div className={style.products}>
          {schema.answers.map((answer, index) =>
            !answer.parent_product && !answer.na ? (
              <Card
                key={answer.id}
                answer={answer}
                schema={schema}
                index={index}
                disabled={'focus' == schema.mode_type && !answer.focused}
                onItemSelect={onItemSelect}
                ref={element => registerCardRef(answer.id, element)}
              />
            ) : null
          )}
        </div>
      </section>
    </>
  )
}

export default Main
